export const FETCH_SEGMENT_LIST = 'FETCH_SEGMENT_LIST';
export const FETCH_SEGMENT_LIST_SUCCESS = 'FETCH_SEGMENT_LIST_SUCCESS';
export const FETCH_SEGMENT_LIST_FAILURE = 'FETCH_SEGMENT_LIST_FAILURE';